import firebase from 'firebase/app'
// Add the Firebase services that you want to use
import "firebase/auth";
import '@firebase/messaging';

const config = {
    apiKey: "AIzaSyB9G3Diy3g-hHhZKM4NC0tRCEbG8TtORhU",
    authDomain: "wellco-65c9d.firebaseapp.com",
    databaseURL: "https://wellco-65c9d.firebaseio.com",
    projectId:      "wellco-65c9d",
    storageBucket: "wellco-65c9d.appspot.com",
    messagingSenderId: "927651637529",
    appId: "1:927651637529:web:56830541e434d925487d88"
};

firebase.initializeApp(config);
//firebase.analytics();
export default firebase;